import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=d6e58af0&scoped=true"
import script from "./AccessDenied.vue?vue&type=script&lang=js"
export * from "./AccessDenied.vue?vue&type=script&lang=js"
import style0 from "./AccessDenied.vue?vue&type=style&index=0&id=d6e58af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e58af0",
  null
  
)

export default component.exports